/**
 * analytics.ts — lightweight client-side event tracking helper.
 *
 * Sends events to POST /api/analytics/track (202 Accepted, rate-limited at 30/min).
 * Errors are caught and silently discarded — analytics must never crash the app.
 * Auth is optional on the backend; the session token is included when available
 * so the backend can attach the user_id to the event.
 */
import { apiFetch } from '@/lib/api'

interface TrackEventOptions {
  properties?: Record<string, unknown>
  pageUrl?: string
}

export async function trackEvent(
  event: string,
  options: TrackEventOptions = {},
): Promise<void> {
  try {
    await apiFetch('/api/analytics/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        event,
        properties: options.properties ?? null,
        pageUrl: options.pageUrl ?? (typeof window !== 'undefined' ? window.location.pathname : null),
      }),
    })
  } catch {
    // Analytics errors are always silent — never break the app.
  }
}
